import { z } from 'zod';
import { uuidSchema } from './common.js';
/** POST /impersonation/start — super_admin only (BP-01 §2.4). */
export const startImpersonationSchema = z.object({ userId: uuidSchema });
//# sourceMappingURL=impersonation.js.map